import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskKbRequestsReports2Route: InvariantJiraRoute = {
	name: 'servicedesk-kb-requests-reports',
	path: '/jira/servicedesk/projects/:projectKey/reports/:reportId(kb-requests-resolved|kb-requests-deflected)',
};
